// extracted by mini-css-extract-plugin
module.exports = {"calcs":"Calculations-styles-module--calcs--18EYs"};